import app from '../../../scripts/app';

import homeownerCtrl from './homeowner.controller';

import template from './homeowner.jade';

app.directive('cianAfHomeowner', () => {
  return {
    template,
    scope: {},
    bindToController: {
      form: '=',
      ad: '=',
    },
    controller: homeownerCtrl,
    controllerAs: 'homeownerCtrl',
    replace: true,
  };
});
